/**
 * Decide de quién es el perfil que se pinta y si es la vista de administración.
 *
 * `isAdmin` deja de deducirse de la navegación —"vino con estado, luego es un
 * administrador"— y pasa a ser una comparación. Eso corrige de paso al
 * administrador que abre su propio perfil desde el listado y hasta ahora veía
 * una pantalla distinta que entrando por el menú.
 */
const resolveEmployeeIdentity = (routeId: string | undefined, loggedUserId: string) => {
  const employeeId = routeId ?? loggedUserId;

  return { employeeId, isAdmin: employeeId !== loggedUserId };
};

export default resolveEmployeeIdentity;
